import React from 'react'
import styled from '@emotion/styled'
import { COLORS } from 'parameters/index'
import { Button } from 'ui/inputs/Button/LegacyButtonCompatibility'

interface IconProps {
	color: string
}
// Remove this component which takes the color prop once we remove ConfirmModal out of the project and use only Modal from Reshaped
const CloseIcon = ({ color }: IconProps): JSX.Element => (
	<svg xmlns="http://www.w3.org/2000/svg" id="icon-close" width="20" height="20" viewBox="0 0 20 20">
		<path id="Area" fill="none" d="M0 0H20V20H0z" />
		<path
			id="Border"
			fill={color}
			d="M9.108 8L16 14.892 14.892 16 8 9.108 1.108 16 0 14.892 6.892 8 0 1.108 1.108 0 8 6.892 14.892 0 16 1.108z"
			transform="translate(2 2)"
		/>
	</svg>
)

interface Props {
	isOpenedDefault?: boolean
	trigger?: JSX.Element
	title: string
	description?: string
	onConfirm: () => void
	onCancel?: () => void
	confirmText: string
	cancelText?: string
	icon?: JSX.Element
	hideCloseIcon?: boolean
}

const ConfirmModal = ({
	isOpenedDefault,
	trigger,
	title,
	description,
	onConfirm,
	onCancel,
	confirmText,
	cancelText,
	icon,
	hideCloseIcon = false
}: Props): JSX.Element => {
	const [isOpened, toggleOpen] = React.useState(false)

	React.useEffect(() => {
		isOpened ? (document.body.style.overflow = 'hidden') : (document.body.style.overflow = 'initial')
	}, [isOpened])

	React.useEffect(() => {
		if (isOpenedDefault) {
			toggleOpen(true)
		}
	}, [isOpenedDefault])

	const closeDialog = (): void => toggleOpen(false)

	const handleConfirm = (): void => {
		onConfirm()
		closeDialog()
	}

	const handleCancel = (): void => {
		onCancel && onCancel()
		closeDialog()
	}
	return (
		<>
			<span onClick={(): void => toggleOpen(true)}>{trigger}</span>
			{isOpened && (
				<Overlay>
					<Modal>
						{!hideCloseIcon && (
							<ModalTop>
								<CloseIconWrapper onClick={(): void => toggleOpen(false)}>
									<CloseIcon color={COLORS.SPANISH_GRAY} />
								</CloseIconWrapper>
							</ModalTop>
						)}
						<ModalBody>
							{icon && <IconWrapper>{icon}</IconWrapper>}
							<ModalTitle>{title}</ModalTitle>
							{description && <ModalDescription>{description}</ModalDescription>}
							<Button onClick={handleConfirm}>{confirmText}</Button>
							{cancelText && <Cancel onClick={handleCancel}>{cancelText}</Cancel>}
						</ModalBody>
					</Modal>
				</Overlay>
			)}
		</>
	)
}

export default ConfirmModal

export const Overlay = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 20px;
	z-index: 999;
`

export const Modal = styled.div`
	width: 600px;
	background: ${COLORS.WHITE};
	padding: 26px;
	border-radius: 4px;
	z-index: 10;
	button {
		margin: 0 auto;
	}
`

const ModalTop = styled.div`
	display: flex;
	justify-content: flex-end;
	margin-bottom: 24px;
`

const ModalBody = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
`

const CloseIconWrapper = styled.div`
	cursor: pointer;
`

const ModalTitle = styled.h2`
	color: ${COLORS.JET_BLACK};
	text-align: center;
	padding-bottom: 32px;
`

const IconWrapper = styled.div`
	margin-bottom: 8px;
`

const ModalDescription = styled.p`
	font-size: 18px;
	font-weight: bold;
	text-align: center;
	margin-bottom: 40px;
`

const Cancel = styled.span`
	display: block;
	text-align: center;
	margin-top: 24px;
	font-size: 16px;
	font-weight: 600;
	color: ${COLORS.MALACHITE_GREEN};
	cursor: pointer;
	text-decoration: underline;
`
